var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("navbar"),
      _c("div", { staticClass: "content" }, [
        _c("h2", [_vm._v("标签库")]),
        _c("h3", [_vm._v("数据筛选")]),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "search",
                attrs: {
                  model: _vm.search,
                  inline: true,
                  id: "search",
                  size: "small",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "标签", prop: "tagName" } },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", placeholder: "标签名称" },
                      model: {
                        value: _vm.search.tagName,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "tagName", $$v)
                        },
                        expression: "search.tagName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "状态", prop: "status" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择状态", clearable: "" },
                        model: {
                          value: _vm.search.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.search, "status", $$v)
                          },
                          expression: "search.status",
                        },
                      },
                      _vm._l(_vm.dictionaries.enable_status, function (item) {
                        return _c("el-option", {
                          key: item.dictId,
                          attrs: { label: item.dictName, value: item.dictId },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "标签分类", prop: "typeFlag" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择分类", clearable: "" },
                        model: {
                          value: _vm.search.typeFlag,
                          callback: function ($$v) {
                            _vm.$set(_vm.search, "typeFlag", $$v)
                          },
                          expression: "search.typeFlag",
                        },
                      },
                      _vm._l(_vm.dictionaries.goods_tag_type, function (item) {
                        return _c("el-option", {
                          key: item.dictId,
                          attrs: { label: item.dictName, value: item.dictId },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "标签类目", prop: "classFlag" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择类目", clearable: "" },
                        model: {
                          value: _vm.search.classFlag,
                          callback: function ($$v) {
                            _vm.$set(_vm.search, "classFlag", $$v)
                          },
                          expression: "search.classFlag",
                        },
                      },
                      _vm._l(_vm.dictionaries.goods_tag_class, function (item) {
                        return _c("el-option", {
                          key: item.dictId,
                          attrs: { label: item.dictName, value: item.dictId },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("search")
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("reset")
                          },
                        },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "content" }, [
        _c("h3", { staticClass: "data-list-title" }, [
          _vm._v("数据列表 "),
          _c(
            "p",
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addNew()
                    },
                  },
                },
                [_vm._v("新增")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "border-color": "#409EFF", color: "#409EFF" },
                  attrs: { size: "small", plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.showDelet(2, "stop")
                    },
                  },
                },
                [_vm._v("批量停用")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "border-color": "#409EFF", color: "#409EFF" },
                  attrs: { size: "small", plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.showDelet(1, "start")
                    },
                  },
                },
                [_vm._v("批量启用")]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticStyle: { width: "100%" } },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.dataList,
                  "highlight-current-row": false,
                  "header-cell-style": {
                    "background-color": "#F8F8F8",
                    color: "#333",
                    fontSize: "16px",
                  },
                },
                on: { "selection-change": _vm.handleSelectionChange },
              },
              [
                _c("el-table-column", { attrs: { type: "selection" } }),
                _c("el-table-column", {
                  attrs: { label: "标签", prop: "tagName" },
                }),
                _c("el-table-column", {
                  attrs: { label: "商品数", prop: "quantity" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.checkGoods(scope)
                                },
                              },
                            },
                            [_vm._v(_vm._s(scope.row.quantity))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "排序", prop: "sort" },
                }),
                _c("el-table-column", {
                  attrs: { label: "标签分类", prop: "typeFlagLabel" },
                }),
                _c("el-table-column", {
                  attrs: { label: "标签类目", prop: "classFlagLabel" },
                }),
                _c("el-table-column", {
                  attrs: { label: "是否对外展示", prop: "showFlag" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-switch", {
                            attrs: {
                              value: scope.row.showFlag == 1 ? true : false,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.getFlagChange($event, scope.row.id)
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "状态", prop: "status" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-switch", {
                            attrs: {
                              value: scope.row.status == 1 ? true : false,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.getStatusChange($event, scope.row.id)
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "创建时间", prop: "createdTime" },
                }),
                _c("el-table-column", {
                  attrs: { label: "操作", prop: "tagName" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "tablebtnbox" }, [
                            _c(
                              "span",
                              {
                                staticClass: "tablebtn",
                                on: {
                                  click: function ($event) {
                                    return _vm.getLabelInfo(scope.row.id, 1)
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "tablebtn",
                                staticStyle: { margin: "0 12px" },
                                on: {
                                  click: function ($event) {
                                    return _vm.getLabelInfo(scope.row.id, 2)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "tablebtn",
                                staticStyle: { color: "#F33F3F" },
                                on: {
                                  click: function ($event) {
                                    return _vm.showDelet(scope.row, "del")
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticStyle: { float: "right", "margin-bottom": "20px" } },
        [
          _vm.dataList.length > 0
            ? _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.pageNo,
                  "page-sizes": [10, 20, 50],
                  "page-size": _vm.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.totalNum,
                },
                on: {
                  "size-change": _vm.onSizeChange,
                  "current-change": _vm.onCurrentChange,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": "",
            visible: _vm.dialogVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _c("i", {
              staticClass: "el-icon-warning",
              style: { color: _vm.statusType == "del" ? "red" : "yellow" },
            }),
            _vm._v(" " + _vm._s(_vm.diologTips) + " "),
          ]),
          _vm._v(" " + _vm._s(_vm.tagName) + " "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.deleteFn()
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.showNewDiolog,
            width: "566px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showNewDiolog = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    "label-width": "110px",
                    rules: _vm.rules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "标签分类", prop: "typeFlag" } },
                    [
                      _vm.writeType == 1
                        ? _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.ruleForm.typeFlag == 1
                                  ? "普通商品"
                                  : "礼包商品"
                              )
                            ),
                          ])
                        : _c(
                            "el-select",
                            {
                              staticStyle: { width: "400px" },
                              attrs: { placeholder: "请选择标签分类" },
                              model: {
                                value: _vm.ruleForm.typeFlag,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "typeFlag", $$v)
                                },
                                expression: "ruleForm.typeFlag",
                              },
                            },
                            _vm._l(
                              _vm.dictionaries.goods_tag_type,
                              function (item) {
                                return _c("el-option", {
                                  key: item.dictId,
                                  attrs: {
                                    label: item.dictName,
                                    value: item.dictId,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "标签类目", prop: "typeFlag" } },
                    [
                      _vm.writeType == 1
                        ? _c(
                            "p",
                            _vm._l(
                              _vm.dictionaries.goods_tag_class,
                              function (item) {
                                return _vm.ruleForm.classFlag == item.dictId
                                  ? _c("span", [_vm._v(_vm._s(item.dictName))])
                                  : _vm._e()
                              }
                            ),
                            0
                          )
                        : _c(
                            "el-select",
                            {
                              staticStyle: { width: "400px" },
                              attrs: { placeholder: "请选择标签类目" },
                              model: {
                                value: _vm.ruleForm.classFlag,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "classFlag", $$v)
                                },
                                expression: "ruleForm.classFlag",
                              },
                            },
                            _vm._l(
                              _vm.dictionaries.goods_tag_class,
                              function (item) {
                                return _c("el-option", {
                                  key: item.dictId,
                                  attrs: {
                                    label: item.dictName,
                                    value: item.dictId,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "标签", prop: "tagName" } },
                    [
                      _vm.writeType == 1
                        ? _c("p", [_vm._v(_vm._s(_vm.ruleForm.tagName))])
                        : _c("el-input", {
                            staticStyle: { width: "400px" },
                            attrs: { placeholder: "请输入标签名称" },
                            model: {
                              value: _vm.ruleForm.tagName,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "tagName", $$v)
                              },
                              expression: "ruleForm.tagName",
                            },
                          }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序", prop: "sort" } },
                    [
                      _vm.writeType == 1
                        ? _c("p", [_vm._v(_vm._s(_vm.ruleForm.sort))])
                        : _c("el-input", {
                            staticStyle: { width: "400px" },
                            attrs: { placeholder: "请输入序号" },
                            on: { input: _vm.getSort },
                            model: {
                              value: _vm.ruleForm.sort,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "sort", $$v)
                              },
                              expression: "ruleForm.sort",
                            },
                          }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否对外展示", prop: "showFlag" } },
                    [
                      _vm.writeType == 1
                        ? _c("p", [
                            _vm._v(
                              _vm._s(_vm.ruleForm.showFlag == 1 ? "是" : "否")
                            ),
                          ])
                        : [
                            _c(
                              "el-radio",
                              {
                                attrs: { label: 1 },
                                model: {
                                  value: _vm.ruleForm.showFlag,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "showFlag", $$v)
                                  },
                                  expression: "ruleForm.showFlag",
                                },
                              },
                              [_vm._v("是")]
                            ),
                            _c(
                              "el-radio",
                              {
                                attrs: { label: 0 },
                                model: {
                                  value: _vm.ruleForm.showFlag,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "showFlag", $$v)
                                  },
                                  expression: "ruleForm.showFlag",
                                },
                              },
                              [_vm._v("否")]
                            ),
                          ],
                    ],
                    2
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态", prop: "status" } },
                    [
                      _vm.writeType == 1
                        ? _c("p", [
                            _vm._v(
                              _vm._s(_vm.ruleForm.status == 1 ? "启用" : "禁用")
                            ),
                          ])
                        : [
                            _c(
                              "el-radio",
                              {
                                attrs: { label: 1 },
                                model: {
                                  value: _vm.ruleForm.status,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "status", $$v)
                                  },
                                  expression: "ruleForm.status",
                                },
                              },
                              [_vm._v("启用")]
                            ),
                            _c(
                              "el-radio",
                              {
                                attrs: { label: 2 },
                                model: {
                                  value: _vm.ruleForm.status,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "status", $$v)
                                  },
                                  expression: "ruleForm.status",
                                },
                              },
                              [_vm._v("禁用")]
                            ),
                          ],
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.cancelFn } }, [
                _vm._v("取 消"),
              ]),
              _vm.writeType == 2
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.saveTagFn },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "商品数据",
            visible: _vm.showGoodsDialog,
            width: "1010px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showGoodsDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "tag—table-box" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.goodsList,
                    "header-cell-style": {
                      background: "#F8F8F8",
                      color: "#333333",
                    },
                    "cell-style": { padding: "0" },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "商品编号", prop: "goodsNo", width: "100" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "商品图片",
                      prop: "imageUrl",
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-image", {
                              staticStyle: {
                                width: "72px",
                                "margin-top": "8px",
                              },
                              attrs: { src: scope.row.imageUrl },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "商品名称", prop: "name" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "商品类型",
                      prop: "typeFlagLabel",
                      width: "100",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "价格", prop: "price", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("p", [_vm._v("￥" + _vm._s(scope.row.price))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "状态", prop: "statusLabel", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "tag-status" }, [
                              _c("div", {
                                staticClass: "circle",
                                style: {
                                  "background-color":
                                    scope.row.statusLabel.indexOf("上架") > -1
                                      ? "#12AB62"
                                      : "red",
                                },
                              }),
                              _c("span", [
                                _vm._v(_vm._s(scope.row.statusLabel)),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "创建时间", prop: "createdTime" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", prop: "", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticStyle: { color: "red" },
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelGoods(scope)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-bottom": "20px",
                    "background-color": "#F8F8F8",
                    overflow: "hidden",
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { float: "right" } },
                    [
                      _vm.goodsList.length > 0
                        ? _c("el-pagination", {
                            attrs: {
                              background: "",
                              "current-page": _vm.goodsPageNo,
                              "page-sizes": [5, 10, 20, 50, 100],
                              "page-size": _vm.goodsPageSize,
                              layout: "total, sizes, prev, pager, next, jumper",
                              total: _vm.goodsTotalNum,
                            },
                            on: {
                              "size-change": _vm.onGoodsSizeChange,
                              "current-change": _vm.onGoodsCurrentChange,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": "",
            visible: _vm.dialogDeleteVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogDeleteVisible = $event
            },
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _c("i", {
              staticClass: "el-icon-warning",
              staticStyle: { color: "red" },
            }),
            _vm._v(" 删除提示 "),
          ]),
          _c("div", [_vm._v("确定删除商品？")]),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogDeleteVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.deleteGoodsFn()
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }